const asynchronouslyImportScript = async (cssSelector: string, path: string) => {
  const elements = document.querySelectorAll<HTMLElement>(cssSelector);
  if (elements.length > 0) {
    const script = await import(`../../templates/_components/${path}`);
    elements.forEach(element => {
      script.default.init(element);
    });
  }
};

export default async () => {
  await asynchronouslyImportScript('#menuApp', 'mainNavigation/mainNavigation');
  await asynchronouslyImportScript('.js-progressPagination', 'slider/progressPagination');
  await asynchronouslyImportScript('.js-overflowSlider', 'slider/overflow');
  await asynchronouslyImportScript('.js-promotionBanner', 'promotionBanner/promotionBanner');
  await asynchronouslyImportScript('.js-slider', 'slider/slider');
  await asynchronouslyImportScript('.js-accordion', 'accordion/accordion');
  await asynchronouslyImportScript('.js-bundesligaOnEar', 'bundesligaOnEar/bundesligaOnEar');
  await asynchronouslyImportScript('.js-countdown', 'countdown/countdown');
  await asynchronouslyImportScript('.js-featuredContentCard', 'cards/featuredContentCard');
  await asynchronouslyImportScript('.js-featuredContent', 'cards/featuredContentProgressBar');
  await asynchronouslyImportScript('.js-heroVideo', 'heros/heroVideo');
  await asynchronouslyImportScript('.js-readMoreText', 'text/readMore');
  await asynchronouslyImportScript('.js-shareBar', 'shareBar/shareBar');
  await asynchronouslyImportScript('.productLinkPins', 'productLinkPins/productLinkPins');
  await asynchronouslyImportScript('.js-cookieOverlay', 'cookieOverlay/cookieOverlay');
};
